import { render, staticRenderFns } from "./ModalUpdate.vue?vue&type=template&id=467c0728"
import script from "./ModalUpdate.vue?vue&type=script&lang=js"
export * from "./ModalUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports